import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  Button,
} from "@mui/material";
import logo from "../assets/images/logo.png";
import phoneicon from "../assets/images/phone-icon.svg";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate
import UserProfileComponent from "./dashboard/UserProfileComponent";
import { useApp } from "../Context/AppContext";
import ProfileMenu from "../components/ProfileMenu";

// const pages = ["Products", "Pricing", "Blog"];

function ResponsiveAppBar() {
  // const [anchorElNav, setAnchorElNav] = React.useState(null); // For the hamburger menu
  const navigate = useNavigate(); // Get navigate function
  const token = localStorage.getItem("jwtToken"); // Get the token from localStorage
  const admin = localStorage.getItem("admin"); // Get the token from localStorage
  const location = useLocation();
  const { pathname } = location;
  const { user } = useApp();

  const buttonText = pathname === "/dashboard" ? "Home" : "Go to Dashboard";

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget); // Set anchor for menu when the hamburger is clicked
  // };

  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null); // Close menu
  // };

  const header_bar = {
    main_header: {
      backgroundColor: "#FFF",
    },
    header_container: {
      padding: "20px 15px",
    },
    header_logo: {
      flexGrow: "0",
      // maxWidth: "240px",
    },
    main_logo: {
      maxWidth: "100%",
    },
    login_btn: {
      backgroundColor: "#FF8634",
      color: "#FFF",
      padding: "10px 20px",
      lineHeight: "1.7",
    },
    menu_icon: {
      fontSize: "45px",
      color: "#065F9C",
      backgroundColor: "none",
    },
    header_phone_link: {
      fontSize: "20px",
      color: "#055C9D",
      display: "flex",
      alignItem: "center",
      fontWeight: "700",
      marginRight: "40px",
      textDecoration: "none",
    },
    header_title: {
      fontSize: "17px",
      color: "#055C9D",
      display: "flex",
      alignItem: "center",
      fontWeight: "500",
      marginRight: "100px",
      textDecoration: "none",
    },
    phone_icon: {
      maxWidth: "30px",
      marginRight: "15px",
    },
  };

  const handleDashboardRedirect = () => {
    if (token) {
      if (pathname === "/dashboard") {
        navigate("/");
        return;
      }
      if (admin) {
        navigate("/admindashboard");
      } else {
        navigate("/dashboard"); // Redirect to dashboard if token exists
      }
    } else {
      navigate("/login"); // Redirect to login if no token
    }
  };

  return (
    <AppBar position="static" style={header_bar.main_header}>
      <Container maxWidth="xl" style={header_bar.header_container}>
        <Toolbar disableGutters>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            {/* Logo on the left */}
            <Box style={header_bar.header_logo} className="logoOuter">
              <Typography>
                <a href="/" style={{ textDecoration: "none" }}>
                  <img
                    style={header_bar.main_logo}
                    src={logo}
                    alt="Logo"
                    className="logo"
                  />
                </a>
              </Typography>
            </Box>
            {/* Spacer to push the hamburger menu to the right */}
            <Box sx={{ flexGrow: 1 }} />

            <Typography
              sx={{
                display: {
                  xs: "none", // hide on extra small screens
                  sm: "none", // hide on small screens
                  md: pathname === "/" ? "flex" : "none", // show as flex on medium and up
                },
                fontSize: "17px",
                color: "#055C9D",
                alignItems: "center", // fix typo: should be alignItems not alignItem
                fontWeight: "500",
                marginRight: "100px",
                textDecoration: "none",
              }}
            >
              Plan your drone flights below and we'll send you a quote.
            </Typography>

            <Box style={header_bar.header_phone} className="phoneNumberHideM">
              <a
                style={header_bar.header_phone_link}
                href="tel:6085717992"
                className="phoneNumber"
              >
                <img
                  style={header_bar.phone_icon}
                  src={phoneicon}
                  alt="Phone"
                />
                (608) 571-7992
              </a>
            </Box>

            {/* Hamburger Menu on the right */}
            <Box sx={{ flexGrow: 0 }}>
              {/* <IconButton
              style={header_bar.menu_icon}
              fontSize="45px"
              size="large"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="#065F9C"
            >
              <MenuIcon />
            </IconButton> */}
              {/* Menu component for navigation */}
              {/* <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu> */}

              {/* Conditional Button */}
              <div className="header_user_profile">
                <Button
                  component="a"
                  style={header_bar.login_btn}
                  onClick={handleDashboardRedirect}
                >
                  {token ? buttonText : "Login/Sign Up"}
                </Button>
                {user?.role === "user" && (
                  <div className="user_profile" style={{ cursor: "pointer" }}>
                    <ProfileMenu>
                      <UserProfileComponent />
                    </ProfileMenu>
                  </div>
                )}
              </div>
            </Box>
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
